"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React, { useState } from "react"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Grid" // Grid version 2
import isInteger from "lodash/isInteger"

import styles from "./styles.module.scss"
import PrimaryAndSecondaryButtonsContainer from "../shared/PrimaryAndSecondaryButtonsContainer"
import SectionContainer from "../shared/SectionContainer"
import {
  PRIMARY_YELLOW_BUTTON_TYPE,
  SECONDARY_BUTTON_TYPE,
} from "../shared/constants"

import PictureSnowman from "./shared/PictureSnowman"
import EmblaCarouselQuotes from "./shared/EmblaCarouselQuotes"
import EmblaCarouselTitle from "./shared/EmblaCarouselTitle"

import { PrevButton, NextButton } from "../shared/YellowArrowButton"
import { TESTIMONIAL_QUOTES } from "./shared/constants"
import useRedirectToLeaderOnboarding from "../../../../hooks/useRedirectToLeaderOnboarding"

function Testimonials() {
  const [
    { isLoggedIn },
    { getRouteForLeaderOnboarding, getMonthlyListingsClickHandler },
  ] = useRedirectToLeaderOnboarding()
  const [pages, setPages] = useState({ currentPage: 0, previousPage: 3 })
  const [inactiveGrayScale, setInactiveGrayScale] = useState(false)

  const renderHeader = () => {
    return (
      <div className={styles["header"]}>
        <Typography variant={"h1"} style={{ marginRight: "10px" }}>
          See what
        </Typography>
        <div className={styles["underline-and-title-container"]}>
          {renderUserTitle()}
        </div>
        <Typography variant={"h1"} sx={{ mr: { xs: "7px", sm: "8px" } }}>
          are
        </Typography>
        <Typography variant={"h1"} style={{ marginRight: "7px" }}>
          saying
        </Typography>
      </div>
    )
  }

  const renderButtons = () => {
    return (
      <PrimaryAndSecondaryButtonsContainer
        button1={{
          type: PRIMARY_YELLOW_BUTTON_TYPE,
          text: "Run your group",
          href: getRouteForLeaderOnboarding(),
        }}
        button2={{
          type: SECONDARY_BUTTON_TYPE,
          text: "Get monthly listings",
          onClick: async () => {
            await getMonthlyListingsClickHandler()
          },
        }}
      />
    )
  }

  const renderButtonsAndPictures = () => {
    return (
      <div
        className={`relative h-[130px] top-0 flex flex-row justify-center min-[600px]:top-[-35px] min-[600px]:h-[150px]`}
      >
        {renderLeftButton()}
        <PictureSnowman
          page={pages.currentPage}
          previousPage={pages.previousPage}
          inactiveGrayScale={inactiveGrayScale}
        />

        {renderRightButton()}
      </div>
    )
  }
  const renderLeftButton = () => {
    return (
      <div
        className={`relative min-[600px]:top-[110px] right-[25px] top-[65px] min-[600px]:right-[22px]`}
      >
        <PrevButton
          onClick={() => {
            if (pages.currentPage == 0) {
              handleChangeIndex(TESTIMONIAL_QUOTES.length - 1)
            } else {
              handleChangeIndex(pages.currentPage - 1)
            }
          }}
          enabled={true}
          onMouseEnter={() => setInactiveGrayScale(true)}
          onMouseLeave={() => setInactiveGrayScale(false)}
        />
      </div>
    )
  }

  const renderRightButton = () => {
    return (
      <div
        className={`relative min-[600px]:top-[110px] left-[13px] top-[65px] min-[600px]:left-[15px]`}
        onClick={() => {
          if (pages.currentPage == TESTIMONIAL_QUOTES.length - 1) {
            handleChangeIndex(0)
          } else {
            handleChangeIndex(pages.currentPage + 1)
          }
        }}
      >
        <NextButton
          onClick={() => {
            if (pages.currentPage == TESTIMONIAL_QUOTES.length - 1) {
              handleChangeIndex(0)
            } else {
              handleChangeIndex(pages.currentPage + 1)
            }
          }}
          enabled={true}
          onMouseEnter={() => setInactiveGrayScale(true)}
          onMouseLeave={() => setInactiveGrayScale(false)}
        />
      </div>
    )
  }

  const handleChangeIndex = (newPage) => {
    if (isInteger(newPage)) {
      setPages({ previousPage: pages.currentPage, currentPage: newPage })
    }
  }

  const renderUserTitle = () => {
    return (
      <EmblaCarouselTitle
        page={pages.currentPage}
        quotes={TESTIMONIAL_QUOTES}
        handleChangePage={handleChangeIndex}
        setInactiveGrayScale={setInactiveGrayScale}
      />
    )
  }

  const renderSwipableView = () => {
    return (
      <div
        className={styles["quote-container"]}
        onMouseEnter={() => setInactiveGrayScale(true)}
        onMouseLeave={() => setInactiveGrayScale(false)}
      >
        <div className={styles["quotation"]}>“</div>
        <Grid
          container
          spacing={0}
          columns={7}
          sx={{
            justifyContent: "center",
            margin: 0,
            padding: 0,
          }}
        >
          <Grid
            size={5}
            sx={{
              padding: 0,
              margin: 0,
            }}
          >
            <EmblaCarouselQuotes
              page={pages.currentPage}
              quotes={TESTIMONIAL_QUOTES}
              handleChangePage={handleChangeIndex}
            />
          </Grid>
        </Grid>
      </div>
    )
  }

  const renderMainBody = () => {
    return (
      <div className={`min-[600px]:pt-[30px]`}>
        {renderButtonsAndPictures()}
        {renderSwipableView()}
      </div>
    )
  }
  return (
    <SectionContainer color="faded-blue">
      {renderHeader()}
      {renderMainBody()}
      {renderButtons()}
    </SectionContainer>
  )
}
export default Testimonials
